import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/outline";
import { ExclamationIcon, XIcon } from "@heroicons/react/outline";
import { CIcon } from "@coreui/icons-react";
import { cifAU } from "@coreui/icons";
import { ThemeProvider } from "@material-ui/core";
import AudioPlayer from "material-ui-audio-player";
//import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import axios from "axios";
import { useTranslation, withTranslation } from "react-i18next";
import { useEffect, useContext } from "react";
import { Context } from "../../themeContext";
//import AudioPlayer from 'material-ui-audio-player';
import { makeStyles, withStyles } from "@material-ui/core/styles";
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk; //const ENDPOINT = "http://192.168.30.40:5004";
function Audiobox(props) {
  const { t } = useTranslation("common");

  const [state, dispatch] = useContext(Context);

  const [open, setOpen] = useState(false);
  function changeetat2(id) {
    //console.log("thisisisisis", id);
  }

  const changetetat = (id) => {
    var lien = window.location.href;
    // console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    var config = {
      headers: {
        Authorization: token,
      },
    };
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/SetConsulteMessageVocallIPBXV3API?compte=${compte}&poste=${poste}&id=${id}`,
        config
      )
      .then((res) => {
        console.log("change etat succes");
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };

  const src = [
    "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
    "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
  ];

  const useStyles = makeStyles((theme) => {
    return {
      root: {
        [theme.breakpoints.down("sm")]: {
          width: "100%",
          padding: "20px!important",
        },

        boxShadow: " 0px 0px 0px red !important",
      },
      loopIcon: {
        color: "#3f51b5",
        "&.selected": {
          color: "#0921a9",
        },
        "&:hover": {
          color: "#7986cb",
        },
        [theme.breakpoints.down("sm")]: {
          display: "none",
        },
      },
      playIcon: {
        color: "rgba(5,150,105,var(--tw-bg-opacity))",
        "&:hover": {
          color: "rgba(52,211,153,var(--tw-bg-opacity))",
        },
        "&.selected": {
          color: "rgba(52,211,153,var(--tw-bg-opacity))",
        },
      },
      replayIcon: {
        color: "#e6e600",
      },
      pauseIcon: {
        color: "rgba(52,211,153,var(--tw-bg-opacity))",
      },
      volumeIcon: {
        color: "rgba(0, 0, 0, 0.54)",
      },
      volumeSlider: {
        color: "rgba(0, 0, 0, 0.54)",
      },
      progressTime: {
        color: "rgba(0, 0, 0, 0.54)",
        marginTop: "15px",
      },

      MuiGridContainer: {},
      mainSlider: {
        marginTop: "13px",
        color: "rgba(5,150,105,var(--tw-bg-opacity))",
        "& .MuiSlider-rail": {
          color: "rgba(5,150,105,var(--tw-bg-opacity))",
        },
        "& .MuiSlider-track": {
          color: "rgba(5,150,105,var(--tw-bg-opacity))",
        },
        "& .MuiSlider-thumb": {
          color: "rgba(5,150,105,var(--tw-bg-opacity))",
        },

        sliderContainerWrapper: {
          padding: "0px!important",

          margin: "0px!important",
        },
      },
    };
  });

  return (
    <Transition.Root show={props.showModal} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        open={open}
        onClose={setOpen}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button
                  type="button"
                  className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  onClick={props.handleClose}
                >
                  <span className="sr-only">Close</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                  <img src="/icon/voicemail.png" alt="icon_voicemail" />
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <Dialog.Title
                    as="h3"
                    className=" text-lg leading-6 font-medium text-gray-900"
                  >
                    {t("Voicemail")}
                  </Dialog.Title>
                </div>
              </div>

              <div className="mt-3 text-center">
                <ThemeProvider>
                  <AudioPlayer
                    useStyles={useStyles}
                    src={props.boite}
                    //displaySlider={false}
                    download={true}
                    autoplay={true}
                    //onPlayed={changeetat2(props.id)}
                  />
                </ThemeProvider>
              </div>

              <div className="sm:mt-3 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="mt-4 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={props.handleClose}
                >
                  {t("close")}
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
export default withTranslation("common")(Audiobox);
